export default __webpack_public_path__ + "static/media/Run.71e83dae.gif";